import { MDBTableBody } from 'mdb-react-ui-kit';
import React from 'react';
import styles from './TableBody.module.css';

export default function TableBody({...props }: any) {
  return (
    <MDBTableBody className={`${styles.tableBody}`}>
      {props.children}
    </MDBTableBody>
  );
}